export default {
      id: "logo--white-usage",
      viewBox: "0 0 2563 438",
      url: "../../assets/" + "sprite.svg#logo--white-usage",
      toString: function () {
        return this.url;
      }
    }